import { useEffect } from "react";

export default function TerminosCondiciones () {
  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])

  return (
    <div className="info-pages terminos">
      <div className="info-header"></div>
      <div className="page-info-content">
        <div className="page-info-header">
          <div className="title">Términos y Condiciones</div>
        </div>
        <div className="page-info-data">
          <div className="subtitle">Condiciones de venta</div>
          <ul>
            <li>Los precios de este sitio, una vez registrado e ingresado al mismo, no incluyen IVA. El IVA se detalla al pie del carrito de compras al finalizar el proceso de pedido.</li>
            <li>Las descripciones de los productos se refieren a las características más relevantes de los mismos. Otras características pueden ser consultadas en las páginas web de los fabricantes.</li>
            <li>Algunos productos pueden sufrir demoras en los plazos de entrega.</li>
            <li>La elección de algunos medios de pago puede generar demoras por requerimientos de información y verificación de esta.</li>
            <li>Liberia del Colegio se reserva el derecho de rechazar un pedido por cuestiones relacionadas a medios de pago, cambios repentinos de precios de los productos y servicios.</li>
            <li>Esta página está exclusivamente desarrollada para compras mayoristas.</li>
            <li>Los clientes que no son de Bahía Blanca deberán especificar el expreso o transporte en el cual se transportará la mercadería, y el costo del mismo quedará a su cargo.</li>
            <li>La compra mínima para pedidos mayoristas es de $300.000,00.</li>
          </ul>
        </div>
      </div>
    </div>
  )
}